import './index.css';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom"
import 'bootstrap/dist/css/bootstrap.min.css'
import PageBinder from './pages/PageBinder';
import Login from './pages/Login';
import TakeActions from './pages/TakeActions';
import TakePolicyAction from './pages/TakePolicyAction';
import "react-multi-carousel/lib/styles.css";
import FeedBackForm from './pages/FeedbackForm/FeedBackForm';
import DocumentDashboard from './pages/dashboard/document/DocumentDashboard';
import 'react-loading-skeleton/dist/skeleton.css'
import HappyFeedback from './pages/HappyFeedback/HappyFeedback';
import StudentSupport from './pages/StudentSupport';
import ThankYouConsent from './components/ThankYouConsent';
import EmailBuilder from './shared/email-builder/EmailBuilder';
import CvDashboard from './pages/dashboard/cv/CvDashboard';
import UniCatDash from './pages/dashboard/UniCatDash';
import ClDashboard from './pages/dashboard/courselist/ClDashboard';
import ApsDashboard from './pages/dashboard/aps/ApsDashboard';
import AppDashboard from './pages/dashboard/application/AppDashboard';
import StudentFunnel from './pages/StudentFunnel';
import { useState } from 'react';
import VisaDashboard from './pages/dashboard/visa/VisaDashboard';
import Refer from './pages/Refer';

function App() {

  const [showSideOverlay, setShowSideOverlay] = useState(false);

  let finalServerURL = process.env.REACT_APP_SERVER_URL
  if (process.env.REACT_APP_MODE !== "production") {
    finalServerURL = process.env.REACT_APP_LOCAL_SERVER_URL
  } else if (process.env.REACT_APP_MODE === "production") {
    finalServerURL = process.env.REACT_APP_SERVER_URL
  }

  const serverURL = finalServerURL

  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Login serverURL={serverURL} />} />
        <Route exact path="/studentSupport" element={<StudentSupport serverURL={serverURL} />} />
        <Route path="/app" element={<PageBinder serverURL={serverURL} />} />
        <Route exact path="/refer" element={<Refer serverURL={serverURL} />} />
        <Route path="/app/:pageType" element={<PageBinder serverURL={serverURL} />} />
        <Route path="/app/:pageType/:pageDesc" element={<PageBinder serverURL={serverURL} />} />
        <Route exact path="/takeactions/:requestId/:useremail" element={<TakeActions serverURL={serverURL} />} />
        <Route exact path="/takepolicyactions/:requestId/:useremail" element={<TakePolicyAction serverURL={serverURL} />} />
        <Route exact path="/feedback/:requestId" element={<FeedBackForm serverURL={serverURL} />} />
        <Route exact path="/survey/:requestId" element={<HappyFeedback serverURL={serverURL} />} />
        <Route path="/student-funnel" element={<StudentFunnel serverURL={serverURL} setShowSideOverlay={setShowSideOverlay} />} />
        <Route path="/doc-dashboard" element={<DocumentDashboard serverURL={serverURL} />} />
        <Route path="/consent/:id" element={<ThankYouConsent serverURL={serverURL} />} />
        <Route path="/doc-dashboard" element={<DocumentDashboard serverURL={serverURL} />} />
        <Route path="/email-builder" element={<EmailBuilder serverURL={serverURL} />} />
        <Route path="/cv-dashboard" element={<CvDashboard serverURL={serverURL} />} />
        <Route path="/cl-dashboard" element={<ClDashboard serverURL={serverURL} />} />
        <Route path="/university-dashboard" element={<UniCatDash serverURL={serverURL} />} />
        <Route path="/aps-dashboard" element={<ApsDashboard serverURL={serverURL} />} />
        <Route path="/app-dashboard" element={<AppDashboard serverURL={serverURL} />} />
        <Route path="/visa-dashboard" element={<VisaDashboard serverURL={serverURL} />} />
        <Route exact path="/*" element={<Login serverURL={serverURL} />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App;